import { render, staticRenderFns } from "./newlearn.vue?vue&type=template&id=4843ee7c&scoped=true&"
import script from "./newlearn.vue?vue&type=script&lang=js&"
export * from "./newlearn.vue?vue&type=script&lang=js&"
import style0 from "./newlearn.vue?vue&type=style&index=0&id=4843ee7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4843ee7c",
  null
  
)

export default component.exports